// TODO: dictionary

import React from "react";

import Radio from "@cayuse/shared-react.components.form.inputs.radio";

import { QuestionFooter, QuestionHeader } from "./Question";
import componentStyles from "./SummaryBudgetComponent.css";

function SummaryBudgetComponent ({ completeFormModel, config, onChange, onDelete }) {
	const onChangeConfig = newProps => onChange(prev => ({ ...prev, ...newProps }));

	return (
		<div role="group" aria-labelledby="budget-summary-label">
			<QuestionHeader config={config} onChangeConfig={onChangeConfig}></QuestionHeader>
			<h3 className={componentStyles.bold}>Budget Summary</h3>
			<p id="budget-summary-label">How would you like to show your budget?</p>
			<div className={componentStyles.radioOptions}>
				<Radio
					checked={false}
					disabled={true}
					id="builder"
					name="builder"
					value="builder"
				>
					Display summary from Budget Builder
				</Radio>
				<Radio
					checked={false}
					disabled={true}
					id="manual"
					name="manual"
					value="manual"
				>
					Manually enter budget information
				</Radio>
			</div>
			<table className={componentStyles.table}>
				<thead className={`ui form`}>
					<tr className={componentStyles.cost}>
						<td><strong>Budget Item</strong></td>
						<td><strong>Total</strong></td>
					</tr>
				</thead>
				<tbody>
					<tr className={componentStyles.total}>
						<td>Total Direct Costs</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.cost}>
						<td>F&amp;A</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.total}>
						<td>Total Sponsor Costs</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.cost}>
						<td>Internal Cost Share</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.cost}>
						<td>External Cost Share</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.total}>
						<td>Total Cost Share</td>
						<td>--</td>
					</tr>
					<tr className={componentStyles.total}>
						<td>Total Project Cost</td>
						<td>--</td>
					</tr>
				</tbody>
			</table>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</div>
	);
}

SummaryBudgetComponent.showInPalette = () => true;

SummaryBudgetComponent.paletteInformation = () => ({
	id: "cayuseSummaryBudgetImporter",
	name: "Summary Budget Importer",
	type: "cayuseSummaryBudgetImporter",
	group: "sponsoredProject"
});

SummaryBudgetComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-summary-budget-importer",
		customStencilId: "null"
	},
	type: "cayuseSummaryBudgetImporter",
	cayuseType: "cayuseSummaryBudgetImporter",
	cayuseShortLabel: "Summary Budget Importer"
});


export default SummaryBudgetComponent;
